export type PublicStatusFreshnessInput = {
  data_revision?: unknown
  latest_match_id?: string | null
}

// The revision is process-local and may reset after a backend restart, so its
// only valid comparison is token equality. latest_match_id preserves rolling
// compatibility with servers that predate data_revision.
export function publicStatusFreshnessToken(status: PublicStatusFreshnessInput): string {
  const rawRevision = status.data_revision
  const revision = typeof rawRevision === 'number' && Number.isSafeInteger(rawRevision) && rawRevision >= 0
    ? String(rawRevision)
    : 'legacy'
  return `${revision}:${status.latest_match_id ?? ''}`
}
